import { useState } from 'react';
import { useModal } from '@/providers/modal';
import { MODAL_IDS } from '@/kit/Modal/keys';
import { useWindowSize } from '@/hooks/useWindowSize';
import { ModalSwipeLayout } from '@/kit/Modal/layouts/swipe';
import { ModalCenterLayout } from '@/kit/Modal/layouts/center';
import { EnterEmailStep } from './EnterEmailStep';
import { ConfirmEmailStep } from './ConfirmEmailStep';
import { DoneStep } from './DoneStep';

const id = MODAL_IDS.change_email_modal;
const steps = {
  enterEmail: 'enterEmail',
  confirmEmail: 'confirmEmail',
  done: 'done',
}

export const ChangeEmailModal = () => {
  const { modalIds } = useModal();
  return modalIds[id] && <Modal />;
};

export const Modal = () => {
  const [step, setStep] = useState(steps.enterEmail);
  const [newEmail, setNewEmail] = useState('');
  const { isMobile } = useWindowSize();
  const { closeModal } = useModal();

  const content = step === steps.enterEmail ? (
    <EnterEmailStep
      email={newEmail}
      onSetEmail={setNewEmail}
      onNext={() => setStep(steps.confirmEmail)}
    />
  ) : step === steps.confirmEmail ? (
    <ConfirmEmailStep
      email={newEmail}
      onBack={() => setStep(steps.enterEmail)}
      onNext={() => setStep(steps.done)}
    />
  ) : (
    <DoneStep
      newEmail={newEmail}
      closeModal={() => closeModal(id)}
    />
  );

  return isMobile ? (
    <ModalSwipeLayout id={id} onClose={() => closeModal(id)} showClose>
      {content}
    </ModalSwipeLayout>
  ) : (
    <ModalCenterLayout id={id} onClose={() => closeModal(id)} showClose>
      {content}
    </ModalCenterLayout>
  )
}
